import Swal from 'sweetalert2';
function sweetAlertTwoButtons(title: any, text: any, type: any, confirmButtonText: any, cancelButtonText?: any) {
    const swalFormat = {
        title,
        text,
        type,
        showCancelButton: cancelButtonText ? true : false,
         confirmButtonColor: cancelButtonText ? '#219ebc' : '#3f3f46',
        cancelButtonColor: '#3f3f46',
        confirmButtonText,
        cancelButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

function sweetAlertOneButtons(title: any, text: any, type: any, confirmButtonText: any) {
    const swalFormat = {
        title,
        text,
        type,
        confirmButtonColor: type === 'warning' || type === 'error' ? '#219ebc' : '#3f3f46',
        confirmButtonText

    };
    return swalFormat;
    // return Swal.fire(
    //     swalFormat
    //   );
}

export function sweetAlert(title: any, text: any, type: any, confirmButtonText: any, cancelButtonText?: any) {
    // if (arguments.length === 5)
    if (arguments.length === 4) {
        return Swal.fire(
            sweetAlertOneButtons(title, text, type, confirmButtonText)
        );
    } else {
        return Swal.fire(
            sweetAlertTwoButtons(title, text, type, confirmButtonText, cancelButtonText)
        );
    }
}

export function sweetAlertWithHtml(title: any, text: any, type: any, confirmButtonText: any, html?: any) {
    return Swal.fire(
        sweetAlertOneButtonsWithHtml(title, text, type, confirmButtonText, html)
    );
}
function sweetAlertOneButtonsWithHtml(title: any, text: any, type: any, confirmButtonText: any, html?: any) {
    const swalFormat = {
        title,
        text,
        type,
        confirmButtonColor: type === 'warning' || type === 'error' ? '#219ebc' : '#3f3f46',
        confirmButtonText,
        html: html || ''
    };
    return swalFormat;
}

